/* eslint-disable */
import request from '../utils/request'

const URL = 'taxi/drivers'
export const getData = (params) => request({
  method: 'get',
  url: URL,
  params
})

export const removeData = (id) => {
  return request({
    url: `${URL}/${id}`,
    method: 'delete'
  })
}

export const getDriverById = (id) => request({
  method: 'get',
  url: `${URL}/${id}`
})

export const addData = (tenantData) => {
  return request({
    method: 'post',
    url: URL,
    data: tenantData
  })
}
